<script lang="ts" setup>
import {
  isCategorie,
  isCommerce,
  isDashboard,
  isProduct,
} from '@/refs/common.refs';
import { useRouter } from 'vue-router';

const router = useRouter();
const goHome = () => {
  router.push('/');
  isDashboard.value = true;
  isCommerce.value = false;
  isProduct.value = false;
  isCategorie.value = false;
};
</script>
<template>
  <div class="flex min-h-screen items-center justify-center bg-yellow-50 p-4">
    <div class="max-w-md rounded-2xl bg-white p-10 text-center shadow-lg">
      <svg
        class="mx-auto mb-6 h-24 w-24 text-yellow-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M12 3v18"
        />
      </svg>

      <h1 class="mb-2 text-5xl font-bold text-gray-900">404</h1>
      <p class="mb-6 text-xl text-gray-500">
        Oups ! La page que vous recherchez n'existe pas.
      </p>

      <!-- Bouton retour -->
      <button
        @click="goHome"
        class="rounded-lg bg-yellow-500 px-6 py-3 font-semibold text-white shadow transition hover:bg-yellow-600"
      >
        Retour à l'accueil
      </button>
    </div>
  </div>
</template>
